/**
 * Runs campaign create action only when prepare succeeds.
 * Shared by all standard ad-type forms (ads-network checking_accounts wiring).
 */
export const applyPreparedCampaignBody = <T extends Record<string, unknown>>(
  body: T,
  prepare: (body: T) => T | null,
  action: (body: T) => void
): boolean => {
  const prepared = prepare(body)

  if (!prepared) {
    return false
  }

  action(prepared)
  return true
}
